import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { useUserController } from '../../../hooks/controllers/user-controller';

const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKeySebrae = '@empretec:sebrae';

const SebraeContext = React.createContext(undefined);

export const SebraeProvider = ({ children }) => {
  const { isAuthenticated, hasRole } = Sebrae.useAuth();
  const { findSebrae } = useUserController();

  const [sebrae, setSebrae] = React.useState(() =>
    cache.hasItem(cacheKeySebrae) ? cache.getItem(cacheKeySebrae) : undefined,
  );
  const [loading, setLoading] = React.useState(() => !cache.hasItem(cacheKeySebrae));

  React.useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }
    if (cache.hasItem(cacheKeySebrae)) {
      setSebrae(cache.getItem(cacheKeySebrae));
      setLoading(false);
      return;
    }
    setLoading(true);
    findSebrae()
      .then((result) => {
        if (result) {
          cache.setItem(cacheKeySebrae, result);
        }
        setSebrae(result);
      })
      .finally(() => setLoading(false));
  }, [isAuthenticated, findSebrae]);

  const value = React.useMemo(() => {
    const isNationalAdmin = sebrae === 'NA' || hasRole('ADMINISTRADOR');
    return {
      sebrae,
      uf: isNationalAdmin ? undefined : sebrae,
      isNationalAdmin,
      loading,
    };
  }, [sebrae, hasRole, loading]);

  return <SebraeContext.Provider value={value}>{children}</SebraeContext.Provider>;
};

export const useSebrae = () => {
  const context = React.useContext(SebraeContext);
  if (context === undefined) {
    throw new Error('useSebrae deve ser usado dentro de um SebraeProvider');
  }
  return context;
};
